import { render, staticRenderFns } from "./18.vue?vue&type=template&id=61f52aac&scoped=true&"
import script from "./18.vue?vue&type=script&lang=js&"
export * from "./18.vue?vue&type=script&lang=js&"
import style0 from "./18.vue?vue&type=style&index=0&id=61f52aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f52aac",
  null
  
)

export default component.exports